import React from 'react';
import { Result, Button } from 'antd';
import { AlertTriangle, RotateCw } from 'lucide-react';

type ErrorFallbackProps = {
  error: Error | string;
  refetch?: () => void;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, refetch }) => {
  const errorMessage = typeof error === 'string' ? error : error.message;

  return (
    <Result
      status="error"
      title="Something went wrong"
      subTitle={errorMessage}
      icon={
        <div className="flex justify-center">
          <AlertTriangle size={48} className="text-red-500" />
        </div>
      }
      extra={
        refetch && (
          <>
            <Button
              type="default"
              onClick={() => (window.location.href = '/')}
              style={{ marginLeft: '8px' }}
            >
              Home
            </Button>
            <Button type="primary" onClick={refetch} icon={<RotateCw size={16} />}>
              Retry
            </Button>
          </>
        )
      }
    />
  );
};

export default ErrorFallback;
